<template>
    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="buttons--row">
                        <div class="search--block">
                            <button
                                class="search--block-btn"
                                type="submit"
                                @click="getListOfShits"
                            >
                                <img src="/img/svg/icons-search.svg" alt="">
                            </button>
                            <input
                                type="search"
                                v-model="filters.search"
                                class="search--block-txt"
                                @input="handleSearch"
                            />
                        </div>
                        <a
                            v-if="addingShift"
                            :href="`/master-admin/shift-board/create`"
                            class="btn btn--outline-primary btn--middle"
                        >
                            + Add New</a>
                    </div>
                    <div class="table-holder table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <nobr>Active Status
                                        <a
                                            href="javascript:void(0)"
                                            v-title="'By activating this shift, employees and applicants will be able to view this schedule and request to work it. Employees and applicants will not be able to see the name of the property, only the city that the property is in.'"><img
                                            src="/img/svg/icons-info.svg" alt=""></a>
                                    </nobr>
                                </th>
                                <th>
                                    <nobr>
                                        Property Name
                                    </nobr>
                                </th>
                                <th class="text-center">Mon</th>
                                <th class="text-center">Tue</th>
                                <th class="text-center">Wed</th>
                                <th class="text-center">Thu</th>
                                <th class="text-center">Fri</th>
                                <th class="text-center">Sat</th>
                                <th class="text-center">Sun</th>
                                <th class="col-min-width">Note</th>
                                <th class="">Priority</th>
                                <th class="text-center">Applicants</th>
                                <th class="text-right">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="shift in shiftBoardList"
                                :key="shift.id"
                            >
                                <td>
                                    <VueToggles
                                        height="30"
                                        width="120"
                                        font-size="14"
                                        checkedText="Active"
                                        uncheckedText="Deactivated"
                                        checkedBg="#60ad45"
                                        uncheckedBg="#e0e1e2"
                                        :value="Boolean(shift.status)"
                                        @click="showCustomModal('switch',`switch`+shift.id)"
                                    />
                                    <ActionModal confirm-text="Proceed" reject-text="Cancel"
                                                 :modalId="getCustomModalId('switch',`switch`+shift.id)"
                                                 @confirm="switchStatus(shift)">
                                        <template #body>
                                            <div class="text-center mb-4" v-if="Boolean(shift.status) === false">
                                                <b>Are you sure you want to activate this shift?</b>
                                                <br>
                                                By activating this shift, employees and applicants will be able to view
                                                this schedule and request to work it.

                                                Employees and applicants will not be able to see the name of the
                                                property, only the city that the property is in
                                            </div>
                                            <div
                                                class="text-center mb-4"
                                                v-else
                                            >
                                                <h4>Are you sure you want to deactivate this shift?</h4>
                                            </div>
                                        </template>
                                    </ActionModal>
                                </td>
                                <td>
                                    {{ shift.client.name }}
                                </td>
                                <td class="text-center">
                                    <div
                                        class="shift-block-adm-shifts"
                                        v-for="(shifts, index) in shift.schedule.monday"
                                        :key="index + 'monday'"
                                    >
                                        <div>{{ shifts }}</div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div
                                        v-for="(shifts, index) in shift.schedule.tuesday"
                                        :key="index + 'tuesday'"
                                        class="shift-block-adm-shifts"
                                    >
                                        <div>{{ shifts }}</div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div
                                        class="shift-block-adm-shifts"
                                        v-for="(shifts, index) in shift.schedule.wednesday"
                                        :key="index + 'wednesday'"
                                    >
                                        <div>{{ shifts }}</div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div
                                        v-for="(shifts, index) in shift.schedule.thursday"
                                        :key="index + 'thursday'"
                                        class="shift-block-adm-shifts">
                                        <div>{{ shifts }}</div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div
                                        class="shift-block-adm-shifts"
                                        v-for="(shifts, index) in shift.schedule.friday"
                                         :key="index + 'friday'">
                                        <div>{{ shifts }}</div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div
                                        v-for="(shifts, index) in shift.schedule.saturday"
                                        :key="index + 'saturday'"
                                        class="shift-block-adm-shifts"
                                    >
                                        <div>{{ shifts }}</div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div
                                        class="shift-block-adm-shifts"
                                        v-for="(shifts, index) in shift.schedule.sunday"
                                        :key="index + 'sunday'"
                                    >
                                        <div>{{ shifts }}</div>
                                    </div>
                                </td>
                                <td>{{ shift.note ?? '' }}</td>
                                <td
                                    :class="{
                                    'text-center': true,
                                    'color--orange': shift.priority === 'medium',
                                     'color--green': shift.priority === 'low',
                                     'color--red': shift.priority === 'high'
                                    }">
                                    {{ shift.priority | capitalizeFirst }}
                                </td>
                                <td class="text-center">
                                    {{ shift.requested_users_count }} <br/>
                                    <a
                                        v-if="shift.requested_users_count > 0"
                                        href="javascript:void(0)"
                                        @click="showCustomModal('eye',`request`+shift.id)"
                                    >
                                        <span class="color--red"><nobr>New Request</nobr></span></a>

                                    <ShiftModal
                                        :modalId="getCustomModalId('eye',`request`+shift.id)"
                                        :shiftInfo="shift"
                                    ></ShiftModal>

                                </td>
                                <td class="text-right">
                                    <div class="action-block">
                                        <a
                                            href="javascript:void(0)"
                                            @click="showCustomModal('eye',`request`+shift.id)"
                                        ><i class="fas fa-eye"></i></a>
                                        <a
                                            v-if="editingShift"
                                            :href="`/master-admin/shift-board/${shift.id}/update`"
                                            class="edit-link"><img
                                            src="/img/svg/icons-pen.svg" alt="">
                                        </a>
                                        <button
                                            v-if="deletingShift"
                                            class="delete-link"
                                            @click="showDeleteModal(shift.id)"
                                        ><img src="/img/svg/on.svg" alt="delete"></button>

                                        <ActionModal confirm-text="Yes" reject-text="No"
                                                     :modalId="getDeleteModalId(shift.id)"
                                                     @confirm="deleteShift(shift.id)">
                                            <template #body>
                                                <div class="text-center mb-4">
                                                    <h4>
                                                        Are you sure you want <br> to delete this item?
                                                    </h4>
                                                </div>
                                            </template>
                                        </ActionModal>

                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changePage="changePage"
                        @changeItemsPerPage="changeItemsPerPage"
                    />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import ShiftBoardService from "./services/ShiftBoardService";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import ShiftModal from "./ShiftModal.vue";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: 'ShiftBoardList',
    props: {
        addingShift: Boolean,
        editingShift: Boolean,
        activatingShift: Boolean,
        deletingShift: Boolean,
    },
    components: {Pagination, ShiftModal, ActionModal},
    mixins: [ ModalHandler, SortDirectionHandler,PaginationHandler],
    data() {
        return {
            loading: true,
            filters: {
                search: '',
                page: 1,
                perPage: 10
            },
            showTooltip: true,
            shiftBoardList: [],
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
        getList(filters) {
            this.getListOfShits(filters)
        },
        async deleteShift(id) {
            this.$showLoadingMessage()
            this.shiftBoardList = this.shiftBoardList.filter((shift) => shift.id !== id)
            try {
                await ShiftBoardService.deleteShift(id)
                this.$showSuccessMessageDelete();
            } catch (error) {
                this.$showErrorMessage('Shift was not deleted. Please reload page and try again.');
            }
        },
        async getListOfShits() {
            try {
                const {data: shiftsData} = await ShiftBoardService.getShiftsInfo(this.filters)
                this.shiftBoardList = shiftsData.data
                this.pagination.current_page = shiftsData.current_page
                this.pagination.last_page = shiftsData.last_page
                this.loading = false
            } catch (e) {
                console.error(e)
                this.$showErrorMessage();
            }
        },
        async switchStatus(shift) {
            this.$showLoadingMessage()
            if(!this.activatingShift) {
                this.$showErrorMessage("You do not have permission to change status")
                return
            }
            try {
                await ShiftBoardService.updateStatus(shift.id);
                await this.getListOfShits()
                this.$showSuccessMessage('Status was changed successfully ');
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Status was not changed. Please try again.');
            }
        },
    },
    mounted() {
        this.getListOfShits();
        this.delayedSearch = createDebouncedFunction(() => this.getListOfShits(), 500);

    }

}

</script>


<style scoped>
</style>
